import React from 'react';
import { Link } from 'react-router-dom';
import { Button, Form, Alert } from 'react-bootstrap';
import { Field, reduxForm } from 'redux-form';
import { TextField } from "../common/FormComponents";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser, faKey, faSpinner } from '@fortawesome/free-solid-svg-icons';

const validate = values => {
    const errors = {}
    if (!values.username) {
        errors.username = '* Required';
    } else if (values.username.length < 2) {
        errors.username = '* Must be more than 2 characters';
    }

    if (!values.password) {
        errors.password = '* Required';
    }
    return errors;
}

const LoginForm = props => {
    const { handleSubmit } = props;

    return (
        <Form onSubmit={handleSubmit}>
            <div className="adt-flex-container">
                <div className="adt-flex-icon">
                    <FontAwesomeIcon className="text-primary" size="lg" icon={faUser} fixedWidth />
                </div>
                <div className="adt-flex-item">
                    <Field component={TextField}
                        name="username"
                        type="text"
                        label="Username"
                        fullWidth
                        autoFocus
                        onChange={this.handleChange}
                        helperText={<span></span>}
                    />
                </div>
            </div>
            <div className="adt-flex-container">
                <div className="adt-flex-icon">
                    <FontAwesomeIcon className="text-primary" size="lg" icon={faKey} fixedWidth />
                </div>
                <div className="adt-flex-item">
                    <Field component={TextField}
                        name="password"
                        type="password"
                        label="Password"
                        fullWidth
                        onChange={this.handleChange}
                        helperText={<span></span>}
                    />
                </div>
            </div>

            { props.errors ? (
                <Alert bsStyle="danger">Incorrect Username or Password.</Alert>
                ) : ( '' )
            }
            <Button type="submit" disabled={props.pristine || props.pending}>
                {(props.pending) ? (
                <FontAwesomeIcon className="text-primary" icon={faSpinner} spin fixedWidth />
                ) : ('')}
                Log In
            </Button>
            <Link to="/reset"> Forgot Password?</Link>
        </Form>
    )
};

export default reduxForm({ form: 'login', validate })(LoginForm)


// WEBPACK FOOTER //
// ./src/Auth/LoginForm.js